import "core-js/modules/es6.object.assign";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import React from 'react';
import styled, { css } from 'styled-components';
/** Text component */

export var BaseText = styled.span.withConfig({
  displayName: "Text__BaseText",
  componentId: "sc-1snl0ya-0"
})(["color:", ";font-size:", ";line-height:", ";text-transform:", ";", ";", ";font-family:", ";", ";", ";"], function (_ref) {
  var color = _ref.color,
      theme = _ref.theme;
  return color ? theme.color(color) : 'inherit';
}, function (_ref2) {
  var size = _ref2.size,
      theme = _ref2.theme;
  return theme.fontSize(size);
}, function (_ref3) {
  var size = _ref3.size,
      theme = _ref3.theme;
  return theme.fontSize(size);
}, function (_ref4) {
  var uppercase = _ref4.uppercase;
  return uppercase ? 'uppercase' : 'inherit';
}, function (_ref5) {
  var weight = _ref5.weight;
  return weight ? "font-weight: ".concat(weight) : null;
}, function (_ref6) {
  var height = _ref6.height;
  return height ? "line-height: ".concat(height) : null;
}, function (_ref7) {
  var family = _ref7.family,
      theme = _ref7.theme;
  return family ? theme.fontFamilies(family) : 'inherit';
}, function (_ref8) {
  var family = _ref8.family;
  return family === 'Anton' ? 'letter-spacing: 0.03rem' : null;
}, function (_ref9) {
  var size = _ref9.size,
      theme = _ref9.theme;
  return size === 'super' ? css(["font-size:", ";line-height:3rem;@media ", "{font-size:", ";line-height:", ";margin-bottom:2rem;}@media ", "{font-size:", ";line-height:", ";margin-bottom:2rem;}"], theme.fontSize('xxl'), theme.breakpoint('small'), theme.fontSize('big'), theme.fontSize('big'), theme.breakpoint('medium'), theme.fontSize('super'), theme.fontSize('super')) : null;
});
/** Text renders different elements based on the `tag` prop
 *  Weight is checked for existence to prevent overriding the tag's css
 */

var Text = function Text(_ref10) {
  var tag = _ref10.tag,
      children = _ref10.children,
      height = _ref10.height,
      weight = _ref10.weight,
      family = _ref10.family,
      rest = _objectWithoutProperties(_ref10, ["tag", "children", "height", "weight", "family"]);

  return React.createElement(BaseText, Object.assign({}, rest, {
    as: tag,
    height: height,
    weight: weight,
    family: family
  }), children);
};

Text.defaultProps = {
  family: 'Montserrat',
  tag: 'span',
  weight: undefined,
  height: undefined,
  uppercase: false,
  size: 's',
  color: 'inherit'
};
export default Text;